export const Svg_131 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M35 27.709c-3.209 0-5.834-1.021-7.875-3.063-2.042-2.041-3.063-4.666-3.063-7.875 0-3.208 1.02-5.833 3.063-7.875C29.166 6.855 31.79 5.834 35 5.834c3.208 0 5.833 1.02 7.875 3.062 2.041 2.042 3.062 4.667 3.062 7.875 0 3.209-1.02 5.834-3.062 7.875-2.042 2.042-4.667 3.063-7.875 3.063Zm0-4.375c1.895 0 3.463-.62 4.703-1.86 1.24-1.24 1.86-2.807 1.86-4.703 0-1.896-.62-3.463-1.86-4.703-1.24-1.24-2.808-1.86-4.703-1.86-1.896 0-3.464.62-4.703 1.86-1.24 1.24-1.86 2.807-1.86 4.703 0 1.896.62 3.464 1.86 4.703 1.24 1.24 2.807 1.86 4.703 1.86ZM11.666 64.167v-19.25c0-1.847.462-3.427 1.386-4.74a8.948 8.948 0 0 1 3.573-2.996c2.479-1.113 5.262-2.12 8.349-3.02 3.086-.898 6.431-1.348 10.033-1.348 3.603 0 6.933.45 9.99 1.349 3.057.9 5.825 1.908 8.305 3.026 1.507.68 2.722 1.677 3.645 2.99.924 1.312 1.386 2.892 1.386 4.74v14.874c0 1.167-.438 2.188-1.313 3.063s-1.895 1.312-3.062 1.312h-25.52c-2.034 0-3.757-.708-5.171-2.124-1.415-1.416-2.122-3.142-2.122-5.177 0-2.035.707-3.758 2.122-5.168 1.414-1.41 3.137-2.114 5.17-2.114h8.604l5.25-11.667a41.112 41.112 0 0 0-3.755-.547 36.393 36.393 0 0 0-3.544-.182c-3.517 0-6.644.401-9.379 1.203-2.735.802-5.148 1.714-7.238 2.734-.681.34-1.24.857-1.677 1.55a4.122 4.122 0 0 0-.657 2.242v19.25h-4.375Zm16.771-4.375h3.938l2.697-5.833h-6.635c-.778 0-1.458.291-2.042.875-.583.583-.875 1.264-.875 2.041 0 .778.292 1.459.875 2.042.584.583 1.264.875 2.042.875Zm8.75 0h16.77V44.917c0-.802-.23-1.55-.692-2.242-.462-.693-1.033-1.21-1.713-1.55a32.328 32.328 0 0 0-2.115-.947 73.58 73.58 0 0 0-2.844-1.094l-9.406 20.708Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={22.458}
        x2={52.434}
        y1={14.584}
        y2={53.395}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)